export default __webpack_public_path__ + "static/media/mastercard-logo.e1b9bed1.png";